import * as i0 from '@angular/core';
import * as i1 from './base-root.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from '@angular/router';
import * as i5 from '@abp/ng.core';
import * as i6 from '@ngx-validate/core';
import * as i7 from './components/validation-error-component/validation-error.component';
import * as i8 from 'ng-zorro-antd/message';
import * as i9 from './global-config.module';
export const BaseRootModuleNgFactory:i0.NgModuleFactory<i1.BaseRootModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any,any> = (<any>(null as any));
var _decl0_3:i2.NgIf<any> = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ɵangular_packages_forms_forms_ba = (<any>(null as any));
var _decl0_12:i3.NgSelectOption = (<any>(null as any));
var _decl0_13:i3.ɵangular_packages_forms_forms_z = (<any>(null as any));
var _decl0_14:i3.DefaultValueAccessor = (<any>(null as any));
var _decl0_15:i3.NumberValueAccessor = (<any>(null as any));
var _decl0_16:i3.RangeValueAccessor = (<any>(null as any));
var _decl0_17:i3.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_18:i3.SelectControlValueAccessor = (<any>(null as any));
var _decl0_19:i3.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_20:i3.RadioControlValueAccessor = (<any>(null as any));
var _decl0_21:i3.NgControlStatus = (<any>(null as any));
var _decl0_22:i3.NgControlStatusGroup = (<any>(null as any));
var _decl0_23:i3.RequiredValidator = (<any>(null as any));
var _decl0_24:i3.MinLengthValidator = (<any>(null as any));
var _decl0_25:i3.MaxLengthValidator = (<any>(null as any));
var _decl0_26:i3.PatternValidator = (<any>(null as any));
var _decl0_27:i3.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_28:i3.EmailValidator = (<any>(null as any));
var _decl0_29:i3.NgModel = (<any>(null as any));
var _decl0_30:i3.NgModelGroup = (<any>(null as any));
var _decl0_31:i3.NgForm = (<any>(null as any));
var _decl0_32:i3.FormControlDirective = (<any>(null as any));
var _decl0_33:i3.FormGroupDirective = (<any>(null as any));
var _decl0_34:i3.FormControlName = (<any>(null as any));
var _decl0_35:i3.FormGroupName = (<any>(null as any));
var _decl0_36:i3.FormArrayName = (<any>(null as any));
var _decl0_37:i4.RouterOutlet = (<any>(null as any));
var _decl0_38:i4.RouterLink = (<any>(null as any));
var _decl0_39:i4.RouterLinkWithHref = (<any>(null as any));
var _decl0_40:i4.RouterLinkActive = (<any>(null as any));
var _decl0_41:i4.ɵangular_packages_router_router_l = (<any>(null as any));
var _decl0_42:i5.ɵl<any,any> = (<any>(null as any));
var _decl0_43:i5.ɵm = (<any>(null as any));
var _decl0_44:i5.ɵn = (<any>(null as any));
var _decl0_45:i5.ɵr = (<any>(null as any));
var _decl0_46:i5.ɵs = (<any>(null as any));
var _decl0_47:i5.ɵt = (<any>(null as any));
var _decl0_48:i5.ɵu = (<any>(null as any));
var _decl0_49:i5.ɵv = (<any>(null as any));
var _decl0_50:i5.ɵx = (<any>(null as any));
var _decl0_51:i5.ɵy = (<any>(null as any));
var _decl0_52:i5.ɵz = (<any>(null as any));
var _decl0_53:i5.ɵbb = (<any>(null as any));
var _decl0_54:i5.ɵbc = (<any>(null as any));
var _decl0_55:i6.ɵa = (<any>(null as any));
var _decl0_56:i6.ɵc = (<any>(null as any));
var _decl0_57:i6.ɵd = (<any>(null as any));
var _decl0_58:i6.ɵe = (<any>(null as any));
var _decl0_59:i7.ValidationErrorComponent = (<any>(null as any));
var _decl0_60:i2.AsyncPipe = (<any>(null as any));
var _decl0_61:i2.UpperCasePipe = (<any>(null as any));
var _decl0_62:i2.LowerCasePipe = (<any>(null as any));
var _decl0_63:i2.JsonPipe = (<any>(null as any));
var _decl0_64:i2.SlicePipe = (<any>(null as any));
var _decl0_65:i2.DecimalPipe = (<any>(null as any));
var _decl0_66:i2.PercentPipe = (<any>(null as any));
var _decl0_67:i2.TitleCasePipe = (<any>(null as any));
var _decl0_68:i2.CurrencyPipe = (<any>(null as any));
var _decl0_69:i2.DatePipe = (<any>(null as any));
var _decl0_70:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_71:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_72:i2.KeyValuePipe = (<any>(null as any));
var _decl0_73:i5.ɵb = (<any>(null as any));
var _decl0_74:i5.ɵba = (<any>(null as any));
var _decl0_75:i5.CoreModule = (<any>(null as any));
var _decl0_76:i8.NzMessageModule = (<any>(null as any));
var _decl0_77:i9.GlobalConfigModule = (<any>(null as any));
var _decl0_78:i6.NgxValidateCoreModule = (<any>(null as any));
var _decl0_79:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_80:i0.ElementRef<any> = (<any>(null as any));
function _View_ValidationErrorComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_ValidationErrorComponent_1_1():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_73.transform(_any.message,_any.interpoliteParams);
  currVal_0;
}
function _View_ValidationErrorComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_59.abpErrors;
  currVal_0;
  const currVal_1:any = _decl0_59.trackByFn;
  currVal_1;
}
